exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".login__login___2D8L1{font-family:Noto Sans,sans-serif}.login__login___2D8L1 h1,.login__login___2D8L1 p{text-align:center}.login__login___2D8L1 p button{padding:10px 40px}.login__login___2D8L1 p img{width:100%;max-width:1400px;margin:50px auto 0}.login__login___2D8L1 label{font-weight:400}", ""]);

// exports
exports.locals = {
	"login": "login__login___2D8L1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/components/styles/login.scss
// module id = 1070
// module chunks = 0